"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _reactScrollCalendar = _interopRequireWildcard(require("react-scroll-calendar"));

require("react-scroll-calendar/build/react-scroll-calendar.css");

var _Element = _interopRequireDefault(require("../01_atoms/Element"));

var _Title = _interopRequireDefault(require("../01_atoms/Title"));

var _ElementGroup = _interopRequireDefault(require("../01_atoms/ElementGroup"));

var _TitledContainer = _interopRequireDefault(require("../01_atoms/TitledContainer"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DateSelectionComponent = function DateSelectionComponent(_ref) {
  var title = _ref.title,
      minDay = _ref.minDay,
      maxDay = _ref.maxDay,
      selectedDay = _ref.selectedDay,
      onChange = _ref.onChange,
      translationManager = _ref.translationManager;
  var lang = translationManager.getCurrentLanguage(); // Set moment locale for MobileCalendar

  (0, _reactScrollCalendar.setMomentLocale)(lang);

  _moment["default"].locale(lang);

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    style: {
      marginTop: 20,
      marginBottom: 10
    }
  }, title), /*#__PURE__*/_react["default"].createElement(_TitledContainer["default"], {
    title: title
  }, /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    style: {
      marginTop: 0
    },
    backgroundColor: "white"
  }, /*#__PURE__*/_react["default"].createElement(_Element["default"], null, /*#__PURE__*/_react["default"].createElement(_reactScrollCalendar["default"], {
    onSelect: function onSelect(_ref2) {
      var startDate = _ref2.startDate;
      return onChange(startDate.format('YYYY-MM-DD'));
    },
    minDate: minDay ? (0, _moment["default"])(minDay, 'YYYY-MM-DD').locale(lang) : undefined,
    selectedDate: selectedDay ? (0, _moment["default"])(selectedDay, 'YYYY-MM-DD').locale(lang) : null,
    maxDate: maxDay ? (0, _moment["default"])(maxDay, 'YYYY-MM-DD').locale(lang) : undefined,
    weekStartsOnMonday: lang !== 'en'
  })))));
};

var _default = DateSelectionComponent;
exports["default"] = _default;